import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as appifyActions from "actions";

const mapStateToProps = (state) => {
  const {
    platformInfo: { display },
    activeApp,
  } = state;

  const activeTemplate =
    (activeApp &&
      activeApp.view &&
      activeApp.view.templates.find((t) => t.id === display.templateId)) ||
    false;

  return {
    ...state,
    activeTemplate,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(appifyActions, dispatch),
});

const withRedux = (component) =>
  connect(mapStateToProps, mapDispatchToProps)(component);

export default withRedux; //all actions are being passed through withRedux
